import React, { useState, useRef, useEffect } from 'react';
import { apiRequest } from '../../api/index';
import DropdownMenu from '../DropdownMenu';

const RegionSelector = ({
  selectedRegions = [],
  onRegionsChange
}) => {
  const [availableRegions, setAvailableRegions] = useState([]);
  // const [showRegions, setShowRegions] = useState(false);
  // const listRef = useRef(null);
  // const dropdownRef = useRef(null);

  // Загружаем доступные регионы сразу при монтировании компонента
  useEffect(() => {
    const loadAvailableRegions = async () => {
      if (availableRegions.length === 0) {
        try {
          const response = await apiRequest('regions', 'GET');
          const loadedRegions = response.data || [];
          loadedRegions.sort((a, b) => a.region.localeCompare(b.region));
          setAvailableRegions(loadedRegions);
        } catch (error) {
          console.error('Ошибка при загрузке регионов:', error);
        }
      }
    };

    loadAvailableRegions();
  }, [availableRegions.length]);

  const handleRegionSelect = (region) => {
    if (!selectedRegions.some(r => r.id === region.id)) {
      onRegionsChange([...selectedRegions, region]);
    }
  };

  // const handleRegionChange = (oldRegion, newRegion) => {
  //   const updatedRegions = selectedRegions.map(r =>
  //     r.id === oldRegion.id ? newRegion : r
  //   );
  //   onRegionsChange(updatedRegions);
  // };

  const handleRegionRemove = (regionToRemove) => {
    const updatedRegions = selectedRegions.filter(r => r.id !== regionToRemove.id);
    onRegionsChange(updatedRegions);
  };

  return (
    <div className="package-regions-section">
      
      <div className="selected-regions-list mt-2">
        {selectedRegions.map(region => (
          <div key={region.id} className="d-flex justify-content-between align-items-center p-2 bg-light rounded mb-2">
            <span className="region-name">{region.region ? region.region : region.name}</span>
            <div className="region-actions d-flex gap-2">
            {/*  <DropdownMenu*/}
            {/*    trigger={*/}
            {/*      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path*/}
            {/*          d="M11.6205 5.62325L12.1613 5.0825C12.5914 4.65233 12.8331 4.0689 12.8331 3.46054C12.8331 2.85219 12.5914 1.16675 12.1613 1.83859C11.7311 1.40842 11.1477 1.16675 10.5393 1.16675C9.93095 1.16675 9.34752 1.40842 8.91735 1.83859L8.3766 2.37934L3.40543 7.34933C3.06885 7.6865 2.90026 7.85509 2.7556 8.04059C2.58491 8.25961 2.43842 8.49646 2.31868 8.747C2.21776 8.95933 2.14251 9.18567 1.99201 9.63717L1.35385 11.5511M11.6205 5.62325C11.6205 5.62325 10.4719 5.55559 9.4581 4.54175C8.44426 3.5285 8.37718 2.37934 8.37718 2.37934M11.6205 5.62325L6.64993 10.5933C6.31335 10.9298 6.14476 11.0984 5.95926 11.2431C5.74024 11.4138 5.50339 11.5603 5.25285 11.68C5.04051 11.7809 4.81476 11.8562 4.36268 12.0067L2.44876 12.6448M2.44876 12.6448L1.98093 12.8012C1.87188 12.8377 1.75479 12.8432 1.64282 12.8168C1.53086 12.7905 1.42845 12.7335 1.34712 12.6521C1.26579 12.5708 1.20876 12.4684 1.18243 12.3564C1.1561 12.2445 1.16153 12.1274 1.1981 12.0183L1.35443 11.5505L2.44876 12.6448Z"*/}
            {/*          stroke="#777777" stroke-width="0.875"/>*/}
            {/*      </svg>*/}
            {/*    }*/}
            {/*    options={availableRegions*/}
            {/*      .filter(r => r.id !== region.id && !selectedRegions.some(sr => sr.id === r.id))*/}
            {/*      .map(r => ({*/}
            {/*        id: r.id,*/}
            {/*        name: r.region ? r.region : r.name*/}
            {/*      }))*/}
            {/*    }*/}
            {/*    onSelect={(option) => {*/}
            {/*      const selectedRegion = availableRegions.find(r => r.id === option.id);*/}
            {/*      handleRegionChange(region, selectedRegion);*/}
            {/*    }}*/}
            {/*    className="dropdown-menu-container"*/}
            {/*    classNameToggle="package-card-info-edit"*/}
            {/*  />*/}
              <div
                  className="package-card-info-edit"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRegionRemove(region);
                  }}
                  aria-label="Удалить регион"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.75 3.5H2.91667H12.25" stroke="#d9534f" stroke-width="0.875" stroke-linecap="round"/>
                  <path
                      d="M4.6665 3.5V2.33333C4.6665 1.62896 5.23212 1.06333 5.9365 1.06333H8.06316C8.76754 1.06333 9.33316 1.62896 9.33316 2.33333V3.5M5.83316 6.41667V9.25M8.1665 6.41667V9.25"
                      stroke="#d9534f" stroke-width="0.875" stroke-linecap="round"/>
                  <path
                      d="M10.5 3.5V11.0833C10.5 11.4809 10.342 11.8622 10.0607 12.1435C9.77936 12.4248 9.39806 12.5833 8.99999 12.5833H4.99999C4.60192 12.5833 4.22062 12.4248 3.93933 12.1435C3.65803 11.8622 3.49999 11.4809 3.49999 11.0833V3.5"
                      stroke="#d9534f" stroke-width="0.875" stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="region-select-container">
        <DropdownMenu
          trigger="Выберите область"
          options={availableRegions
            .filter(region => !selectedRegions.some(r => r.id === region.id))
            .map(region => ({
              id: region.id,
              name: region.region ? region.region : region.name
            }))
          }
          onSelect={(option) => {
            const selectedRegion = availableRegions.find(r => r.id === option.id);
            handleRegionSelect(selectedRegion);
          }}
          // className=""
          classNameToggle="btn btn-region-select"
        />
      </div>
    </div>

  );
};

export default RegionSelector;
